// ==========================
// Swym Wishlist Purchase Tracking
// PDP-only version for THREE
// No timestamp version
// ==========================
(function () {
  if (window.__swymWishlistTrackingPDPOnly) return;
  window.__swymWishlistTrackingPDPOnly = true;

  const WISHLIST_WINDOW = 5000;

  let wishlistClickAt = 0;
  let wishlistVariantId = null;
  let verifying = false;

  function getProps() {
    return {
      '_purchase_source': 'wishlist',
      '_wishlist_source': 'swym'
    };
  }

  function getCurrentVariantId() {
    return (
      document.querySelector('form[action*="/cart/add"] [name="id"]')?.value ||
      document.querySelector('[name="id"]')?.value ||
      null
    );
  }

  function markWishlistIntent(source, variantId) {
    wishlistClickAt = Date.now();
    wishlistVariantId = variantId || getCurrentVariantId();

    console.log('[Wishlist Tracking] wishlist marked:', {
      source: source,
      variantId: wishlistVariantId
    });
  }

  function isWishlistAdd(currentVariantId) {
    if (!wishlistClickAt) return false;
    if (Date.now() - wishlistClickAt > WISHLIST_WINDOW) return false;

    if (wishlistVariantId && currentVariantId) {
      return String(wishlistVariantId) === String(currentVariantId);
    }

    return true;
  }

  function attachPropertiesToBody(body) {
    if (!body) return body;

    if (body instanceof FormData) {
      const currentId = body.get('id') || getCurrentVariantId();

      if (!isWishlistAdd(currentId)) return body;

      wishlistVariantId = wishlistVariantId || String(currentId);

      body.set('properties[_purchase_source]', 'wishlist');
      body.set('properties[_wishlist_source]', 'swym');

      return body;
    }

    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);

        if (Array.isArray(parsed.items)) {
          parsed.items = parsed.items.map(function (item) {
            const currentId = item.id || item.variant_id;

            if (!isWishlistAdd(currentId)) return item;

            wishlistVariantId = wishlistVariantId || String(currentId);

            return {
              ...item,
              properties: {
                ...(item.properties || {}),
                ...getProps()
              }
            };
          });
        } else {
          const currentId = parsed.id || parsed.variant_id || getCurrentVariantId();

          if (!isWishlistAdd(currentId)) return body;

          wishlistVariantId = wishlistVariantId || String(currentId);

          parsed.properties = {
            ...(parsed.properties || {}),
            ...getProps()
          };
        }

        return JSON.stringify(parsed);
      } catch (err) {
        return body;
      }
    }

    return body;
  }

  async function verifyCartProperty() {
    if (!wishlistVariantId || verifying) return;

    verifying = true;

    try {
      const cart = await fetch('/cart.js').then(res => res.json());

      const item = cart.items.find(function (line) {
        return String(line.variant_id) === String(wishlistVariantId);
      });

      if (!item) return;

      const hasSource =
        item.properties &&
        item.properties._purchase_source === 'wishlist' &&
        item.properties._wishlist_source === 'swym';

      if (hasSource) return;

      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: {
            ...(item.properties || {}),
            ...getProps()
          }
        })
      });
    } catch (err) {
      console.warn('[Wishlist Tracking] verify failed', err);
    } finally {
      verifying = false;
      wishlistClickAt = 0;
      wishlistVariantId = null;
    }
  }

  // ==========================
  // WISHLIST CLICK DETECT
  // fallback เผื่อ Swym ไม่ผ่าน _swat hook
  // ==========================
  document.addEventListener('click', function (e) {
    const btn = e.target.closest(
      '[class*="swym"], [class*="wish"], [id*="wish"], [aria-label*="wish"], [title*="wish"], [data-swaction*="wishlist"], button, a'
    );

    if (!btn) return;

    const text = (btn.textContent || '').toLowerCase();
    const aria = (btn.getAttribute('aria-label') || '').toLowerCase();
    const title = (btn.getAttribute('title') || '').toLowerCase();
    const cls = (btn.className || '').toString().toLowerCase();
    const id = (btn.id || '').toLowerCase();
    const action = (btn.getAttribute('data-swaction') || '').toLowerCase();

    const looksLikeWishlist =
      cls.includes('swym') ||
      cls.includes('wish') ||
      id.includes('wish') ||
      aria.includes('wish') ||
      title.includes('wish') ||
      action.includes('wishlist') ||
      text.includes('wishlist') ||
      text.includes('รายการโปรด');

    if (!looksLikeWishlist) return;

    const variantId =
      btn.dataset.variantId ||
      btn.dataset.epi ||
      btn.getAttribute('data-variant-id') ||
      btn.getAttribute('data-epi') ||
      getCurrentVariantId();

    markWishlistIntent('click', variantId);
  }, true);

  // ==========================
  // SWYM API HOOK
  // main detect สำหรับตอน Swym addToWishList ถูกเรียก
  // ==========================
  (function waitForSwym() {
    if (!window._swat || !window._swat.addToWishList) {
      setTimeout(waitForSwym, 300);
      return;
    }

    const originalAddToWishList = window._swat.addToWishList;

    window._swat.addToWishList = function (data, callback) {
      const variantId =
        data && (data.epi || data.variantId || data.variant_id);

      markWishlistIntent('swym-api', variantId ? String(variantId) : getCurrentVariantId());

      return originalAddToWishList.apply(this, arguments);
    };

    console.log('[Wishlist Tracking] Swym hook ready');
  })();

  // ==========================
  // FORM SUBMIT INTERCEPT
  // เผื่อ theme submit form ตรง ๆ
  // ==========================
  document.addEventListener('submit', function (e) {
    const form = e.target;

    if (!form || !form.action || !form.action.includes('/cart/add')) return;

    const formData = new FormData(form);
    const variantId = formData.get('id') || getCurrentVariantId();

    if (!isWishlistAdd(variantId)) return;

    let input1 = form.querySelector('[name="properties[_purchase_source]"]');
    if (!input1) {
      input1 = document.createElement('input');
      input1.type = 'hidden';
      input1.name = 'properties[_purchase_source]';
      input1.value = 'wishlist';
      form.appendChild(input1);
    }

    let input2 = form.querySelector('[name="properties[_wishlist_source]"]');
    if (!input2) {
      input2 = document.createElement('input');
      input2.type = 'hidden';
      input2.name = 'properties[_wishlist_source]';
      input2.value = 'swym';
      form.appendChild(input2);
    }

    console.log('[Wishlist Tracking] Form inject success');
  }, true);

  // ==========================
  // XHR INTERCEPT
  // ==========================
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__wishlistTrackUrl = url;
    return originalOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function (body) {
    const url = this.__wishlistTrackUrl || '';
    const isCartAdd = url.includes('/cart/add');

    if (isCartAdd && wishlistClickAt) {
      body = attachPropertiesToBody(body);

      this.addEventListener('loadend', function () {
        setTimeout(verifyCartProperty, 300);
      });
    }

    return originalSend.call(this, body);
  };

  // ==========================
  // FETCH INTERCEPT
  // ==========================
  const originalFetch = window.fetch;

  window.fetch = function (input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    const isCartAdd = url.includes('/cart/add');

    if (isCartAdd && wishlistClickAt && init.body) {
      init.body = attachPropertiesToBody(init.body);

      return originalFetch(input, init).then(function (res) {
        setTimeout(verifyCartProperty, 300);
        return res;
      });
    }

    return originalFetch(input, init);
  };
})();